import { render, staticRenderFns } from "./nxMobileMycomponent.vue?vue&type=template&id=60bdd688&scoped=true&"
import script from "./nxMobileMycomponent.vue?vue&type=script&lang=js&"
export * from "./nxMobileMycomponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdd688",
  null
  
)

export default component.exports